export default __webpack_public_path__ + "static/media/I99.a8c4014f.jpg";